import ContentLoader from 'react-content-loader'
import { useTheme } from 'styled-components'

export const TableContentLoader = () => {
  const theme = useTheme()

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={630}
      backgroundColor={theme.colors.contentLoader.backgroundColor}
      foregroundColor={theme.colors.contentLoader.foregroundColor}
      style={{ marginTop: 16 }}
    >
      {Array.from({ length: 10 }).map((_, rowIndex) => (
        <rect key={rowIndex} x="0" y={rowIndex * (48 + 16)} rx="5" ry="5" width="100%" height="48" />
      ))}
    </ContentLoader>
  )
}
